import ListRole from "../views/ListRole.vue";

export default [
  {
    path: "roles",
    component: ListRole,
    meta: { requiresAuth: true, permissions: "access_level,list_access_level" },
  },
];
